import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, setAuthToken } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id });
        setAuthToken(res.data.session_token);
        setUser(res.data.user);
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/app/home", { replace: true });
      } catch (e) {
        console.error("Google OAuth session exchange failed", e);
        navigate("/login?error=oauth_failed", { replace: true });
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-background">
      <Logo />
      <div className="font-mono text-sm text-muted-foreground">Signing you in…</div>
    </div>
  );
}
